var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaintsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4733 4H11.5267L4.5 11.0267V20.9733L11.5267 28H21.4733L28.5 20.9733V11.0267L21.4733 4ZM25.8333 19.8667L20.3667 25.3333H12.6333L7.16667 19.8667V12.1333L12.6333 6.66667H20.3667L25.8333 12.1333V19.8667Z",
    fill: "#2D4BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.6667C17.2364 22.6667 17.8333 22.0697 17.8333 21.3333C17.8333 20.597 17.2364 20 16.5 20C15.7636 20 15.1667 20.597 15.1667 21.3333C15.1667 22.0697 15.7636 22.6667 16.5 22.6667Z",
    fill: "#2D4BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 9.33333H17.8333V18.6667H15.1667V9.33333Z",
    fill: "#2D4BF3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintsB);
export default __webpack_public_path__ + "static/media/complaints_b.f8b2046b35b21cf4f1eda6b58df43acb.svg";
export { ForwardRef as ReactComponent };